import type { Dispatch, SetStateAction } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { EditorState } from "../connectorManagerHelpers";

export const WebhookFields = ({
  editor,
  setEditor,
}: {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
}) => (
  <>
    <div className="space-y-2">
      <Label htmlFor="connector-url">Target URL</Label>
      <Input
        id="connector-url"
        type="url"
        value={editor.targetUrl}
        onChange={(e) => setEditor((s) => ({ ...s, targetUrl: e.target.value }))}
        placeholder="https://example.com/incoming"
      />
    </div>
    <div className="grid gap-2 sm:grid-cols-2">
      <div className="space-y-2">
        <Label htmlFor="connector-header">Auth header name (optional)</Label>
        <Input
          id="connector-header"
          value={editor.authHeaderName}
          onChange={(e) => setEditor((s) => ({ ...s, authHeaderName: e.target.value }))}
          placeholder="X-Auth-Token"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="connector-secret">
          Auth header value {editor.connector ? "(leave blank to keep)" : ""}
        </Label>
        <Input
          id="connector-secret"
          type="password"
          autoComplete="new-password"
          value={editor.secretValue}
          onChange={(e) => setEditor((s) => ({ ...s, secretValue: e.target.value, clearSecret: false }))}
          placeholder="Stored encrypted"
        />
        {editor.connector && (
          <label className="flex items-center gap-2 text-xs text-muted-foreground">
            <input
              type="checkbox"
              checked={editor.clearSecret}
              onChange={(e) => setEditor((s) => ({ ...s, clearSecret: e.target.checked, secretValue: "" }))}
            />
            Clear stored secret
          </label>
        )}
      </div>
    </div>
  </>
);
